module.exports = __webpack_public_path__ + "img/pestana-roja.53be3d37.png";